// extracted by mini-css-extract-plugin
export default {"sideMenuItem":"SideMenuItem_sideMenuItem__ODkWI","icon":"SideMenuItem_icon__dh7Db","menuLink":"SideMenuItem_menuLink__vZ5E6","text":"SideMenuItem_text__3ARLr"};